
export const ENABLE_NOTIFICATION_SOUND = "enable_notification_sound";
export const NOTIFICATION_SOUND_NEXT_INTERVAL = "notification_sound_next_interval";


const STORAGE_PREFIX = "snp_"; // optional prefix

const isBrowser = typeof window !== "undefined";

const safeStorage = {
    set: (storage, key, value) => {
        try {
            storage.setItem(key, JSON.stringify(value));
            return true;
        } catch (err) {
            console.warn("Storage set failed:", err);
            return false;
        }
    },

    get: (storage, key, defaultValue) => {
        try {
            const raw = storage.getItem(key);
            if (!raw) return defaultValue;

            const parsed = JSON.parse(raw);

            // TTL check
            if (parsed?.__ttl && Date.now() > parsed.__ttl) {
                storage.removeItem(key);
                return defaultValue;
            }

            return parsed?.value ?? parsed;
        } catch (err) {
            console.warn("Storage get failed:", err);
            return defaultValue;
        }
    },

    remove: (storage, key) => {
        try {
            storage.removeItem(key);
        } catch (err) {
            console.warn("Storage remove failed:", err);
        }
    }
};

// -----------------------------
// Public API
// -----------------------------

export const SnpLocalStorage = {
    set(key, value, ttlMs = null) {
        if (!isBrowser) return;

        const namespacedKey = STORAGE_PREFIX + key;

        const data = ttlMs
            ? { value, __ttl: Date.now() + ttlMs }
            : { value };

        safeStorage.set(localStorage, namespacedKey, data);
    },

    get(key, defaultValue = null) {
        if (!isBrowser) return defaultValue;

        const namespacedKey = STORAGE_PREFIX + key;

        return safeStorage.get(localStorage, namespacedKey, defaultValue);
    },

    remove(key) {
        if (!isBrowser) return;

        const namespacedKey = STORAGE_PREFIX + key;

        safeStorage.remove(localStorage, namespacedKey);
    },

    // Handy option: Clear all your app keys only
    clearAll() {
        if (!isBrowser) return;

        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith(STORAGE_PREFIX)) {
                localStorage.removeItem(key);
            }
        });
    }
};